'use client'

import { useAtomValue } from 'jotai'
import { useEffect } from 'react'
import { currentLocaleAtom, isRtlAtom } from './locale'

export function LocaleProvider() {
  const locale = useAtomValue(currentLocaleAtom)
  const isRtl = useAtomValue(isRtlAtom)

  useEffect(() => {
    const html = document.documentElement
    html.lang = locale
    html.dir = isRtl ? 'rtl' : 'ltr'
  }, [locale, isRtl])

  return null
}
